












































import Vue from "vue";
import { ItemConditionOptions } from "../../types";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {
      dropdownOptions: ItemConditionOptions,
      dropdownSelected: {
        name: "",
        display_name: ""
      }
    };
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean
    }
  },
  inject: ["actionHandler"],
  computed: {
    isSampleIssued() {
      if ((this as any).row.status && (this as any).row.status === "ISSUED") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    checkboxChanged(changeEvent: { target: { checked: boolean } }) {
      (this.row as any).checked = changeEvent.target.checked;
      this.actionHandler("row_checkbox", this.row);
    },
    onDropdownOptionSelected(selected: { name: string; display_name: string }) {
      this.dropdownSelected = selected;
      (this.row as any)[(this.column as any).name] = selected;
    },
    handleOpenEvent() {
      this.$emit("focus");
    }
  }
});
